import React, { Component } from "react";
import NavigationBar from "@safecv/core/NavigationBar";
import "./AddPlan.css";
import Upload from "./Upload";
import Disciplines from "./Disciplines";
import leftarrow from "@safecv/assets/Images/leftarrow.png";
import Footer from "./Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchCriteria,
  createFormDataPost,
  fetchStateList,
  fetchJurisdictionList,
  fetchPlanType,
  fetchCodebook,
  uploadGT,
  redirect,
  getDocumentTypes,
} from "@safecv/actions/postActions";
import { Link } from "react-router-dom";
import toast from "@safecv/shared/toast";
import API from "@safecv/api";
import MESSAGE from "@safecv/shared/message";
import FadeLoader from "react-spinners/FadeLoader";
import { override } from "@safecv/shared/sharedFunction";
import axios from "axios";
import AppFooter from "@safecv/core/AppFooter";
import moment from "moment";
import API_CONFIG from "@safecv/src/api-config";
import { restPlantype, resetCodebook } from "@safecv/src/Actions/types";

class AddPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      selectedUploadedFile: null,
      gtFile: null,
      planName: "",
      file: [],
      state: "",
      stateId: "",
      jurisdictionId: null,
      criterialist: [],
      disciplines: [],
      selectedjurisdiction: "",
      selectedstate: "",
      isFlushed: false,
      selectedPlanType: "",
      planTypeId: null,
      selectedEffectiveFrom: moment(new Date()).format("MM/DD/YYYY"),
      selectedDueDate: moment(new Date()).add(7, "d").format("MM/DD/YYYY"),
      selectedCodebook: null,
      codebookId: null,
      share_isChecked: false,
      isOriginalPlan: true,
      isAdditional: null,
      uploadedAddDocs: [],
    };
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  handleStateListChange = (item) => {
    this.setState(
      {
        state: item.label,
        stateId: item.value,
        jurisdictionId: null,
        selectedjurisdiction: "",
        selectedPlanType: "",
        selectedCodebook: null,
        codebookId: null,
        planTypeId: null,
      },
      this.props.fetchJurisdictionList(item.value)
    );
    this.props.planTypes.length > 0 && this.props.restPlantype();
    this.props.codebooks.length > 0 && this.props.resetCodebook();
  };

  handleJurisdictionListChange = (item) => {
    this.setState(
      {
        jurisdictionId: item.value,
        selectedjurisdiction: item.label,
        planTypeId: null,
        selectedPlanType: "",
        selectedCodebook: null,
        codebookId: null,
      },
      this.props.fetchPlanType(item.value)
    );
    this.props.codebooks.length > 0 && this.props.resetCodebook();
  };

  handlePlanTypeListChange = (item) => {
    this.setState(
      {
        planTypeId: item.value,
        selectedPlanType: item.label,
        selectedCodebook: null,
        codebookId: null,
      },
      () => {
        if (
          this.state.planTypeId &&
          this.state.stateId &&
          this.state.jurisdictionId
        )
          this.props.fetchCodebook(
            this.state.stateId,
            this.state.jurisdictionId,
            this.state.planTypeId,
            API_CONFIG.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED
              ? moment().format("MM/DD/YYYY")
              : "01/01/1900"
          );
      }
    );
  };

  handleCodebookListChange = (item) => {
    this.setState({
      codebookId: item.value,
      selectedCodebook: item.label,
    });
  };

  handleEffectiveFromChange = (item) => {
    if (
      this.state.stateId &&
      this.state.jurisdictionId &&
      this.state.planTypeId
    ) {
      let date = moment(item).format("MM/DD/YYYY");
      this.setState({
        selectedEffectiveFrom: date,
      });

      this.props.fetchCodebook(
        this.state.stateId,
        this.state.jurisdictionId,
        this.state.planTypeId,
        date
      );
    } else {
      if (this.state.state === "") {
        toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.STATE);
      } else if (this.state.jurisdictionId === null) {
        toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.JURIDICTION);
      } else if (this.state.planTypeId === null) {
        toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.PLANTYPE);
      }
    }
  };

  handleDueDateChange = (item) => {
    let date = moment(item).format("MM/DD/YYYY");
    this.setState({
      selectedDueDate: date,
    });
  };

  componentWillReceiveProps(props) {
    if (!this.state.planTypeId) {
      if (props.planTypes && props.planTypes.length === 1)
        this.handlePlanTypeListChange({
          value: props.planTypes[0].id,
          label: props.planTypes[0].planType,
        });
      //remove the previous state when the plantype is multiple
      else if (this.state.planType === null && props.planTypes.length > 1) {
        this.handlePlanTypeListChange({
          value: "",
          label: "",
        });
      }
    } else if (!this.state.codebookId) {
      if (props.codebooks)
        this.state.selectedPlanType &&
          this.state.selectedPlanType.toLowerCase() === "residential" &&
          props.codebooks.forEach((item) => {
            if (item.codebookNameDefault) {
              this.handleCodebookListChange({
                value: item.id,
                label: item.codebookName,
              });
            }
          });
    }
  }

  componentDidMount() {
    this.criteria();
    this.props.fetchStateList();
    this.props.getDocumentTypes();
  }

  componentDidUpdate(prevProps, prevState) {
    //Prefill plan and codebook
    //whenever jurisdiction is selected, plan is not selected and plantypes are available
    //on jurisdiction selection -> plan is reset
    if(this.state.selectedjurisdiction.length > 0 && this.state.selectedPlanType.length === 0 && this.props.planTypes.length > 0) {
      this.handlePlanTypeListChange({label: this.props.planTypes[0]['planType'], value: this.props.planTypes[0]['id'] })
    }
  }

  openModal = (isOriginalPlan) => {
    this.setState({
      modalIsOpen: true,
      isOriginalPlan: isOriginalPlan,
    });
  };

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  updateModal = () => {
    // setting the file name in the input field
    document.getElementById(
      "fileUpload-" + this.state.isOriginalPlan
    ).value = this.state.isOriginalPlan
      ? this.state.selectedUploadedFile.name
      : this.state.gtFile.name;
    //Prefill Plan Name only when main File is uploaded and not for GT file
    if(this.state.isOriginalPlan) {
      let planname = this.state.selectedUploadedFile.name
      planname = planname.substr(0, planname.lastIndexOf('.')) 
      this.setState({
        planName: planname
      })
    }
    this.setState({ modalIsOpen: false });
  };

  onChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  selectAllCheckBoxes = (e) => {
    let criterialist = this.state.criterialist;
    criterialist.forEach((obj) => {
      obj.isChecked = e.target.checked;
    });
    let selectedDisciplines = [];
    for (let val of criterialist) {
      val.isChecked = e.target.checked;
      if (val.isChecked) {
        selectedDisciplines.push(val.id);
      }
    }

    const selectedDisciplinesNames = selectedDisciplines.map((val) => {
      return val.name;
    });
    this.setState({
      criterialist: criterialist,
      isChecked: !this.state.isChecked,
      disciplines: selectedDisciplines,
      selectedDisciplinesNames: selectedDisciplinesNames,
    });
  };

  toggleCheckBoxChange = (obj) => {
    let criterialist = this.state.criterialist;
    let selectedDisciplines = this.state.disciplines;
    let selCount = 0;

    criterialist.forEach((val) => {
      if (val.id === obj.id) {
        val.isChecked = !val.isChecked;
        if (val.isChecked) {
          selectedDisciplines.push(val.id);
        } else {
          selectedDisciplines = selectedDisciplines.filter(
            (no) => no !== val.id
          );
        }
      }
    });

    try {
      for (let list of criterialist) {
        if (list.isChecked === true) {
          selCount++;
        }
      }
      if (selCount === criterialist.length) {
        document.getElementById("sel-all-desc").checked = true;
      } else {
        document.getElementById("sel-all-desc").checked = false;
      }
    } catch (e) {
      console.error(e);
    }

    const selectedDisciplinesNames = selectedDisciplines.map((val) => {
      return val.name;
    });
    this.setState({
      criterialist: criterialist,
      isChecked: !this.state.isChecked,
      disciplines: selectedDisciplines,
      selectedDisciplinesNames: selectedDisciplinesNames,
    });
  };

  criteria = () => {
    axios.get(API.ADDPLAN.DISCIPLINE).then((res) => {
      let criterialist = res.data;
      criterialist.forEach((obj) => {
        obj["isChecked"] = true;
      });

      try {
        // disabling select all
        // document.getElementById("sel-all-desc").checked = true;
        let selectedDisciplines = this.state.disciplines;
        criterialist.forEach((val) => {
          if (val.isChecked) {
            selectedDisciplines.push(val.id);
          } else {
            selectedDisciplines = selectedDisciplines.filter(
              (no) => no !== val.id
            );
          }
        });

        this.setState({
          criterialist: criterialist,
          disciplines: selectedDisciplines,
        });
      } catch (e) {
        console.error("error in checkbox");
      }
    });
  };

  updateUploadedFile = (files) => {
    if (this.state.isOriginalPlan) {
      this.setState({
        selectedUploadedFile: files,
      });
    } else {
      this.setState({
        gtFile: files,
      });
    }
  };

  shareCheckBoxToggle = (e) => {
    this.setState({
      share_isChecked: e.target.checked,
    });
  };

  handleProcessPlan = async () => {
    const { uploadedAddDocs } = this.state;
    const { documentTypes } = this.props;

    let supportDocNameValues = [];
    let supportDocNameDuplicates = false;

    uploadedAddDocs.forEach((file) => {
      supportDocNameValues.push(file.name);
    });

    let supportDocNameUniqueValue = [...new Set(supportDocNameValues)];
    if (supportDocNameUniqueValue.length < uploadedAddDocs.length)
      supportDocNameDuplicates = true;

    // validating the all data
    if (
      this.state.planName !== "" &&
      this.state.selectedUploadedFile &&
      this.state.state !== "" &&
      this.state.jurisdictionId !== null &&
      this.state.disciplines.length !== 0 &&
      this.state.planTypeId !== null &&
      ((this.state.selectedPlanType.toLowerCase() === "residential" &&
        this.state.codebookId !== null) ||
        this.state.selectedPlanType.toLowerCase() === "commercial") &&
      !supportDocNameDuplicates
    ) {
      let data = new FormData();
      data.append("file", this.state.selectedUploadedFile);
      data.append("planName", this.state.planName);
      data.append("jurisdictionId", this.state.jurisdictionId);
      data.append("codebookId", this.state.codebookId);
      data.append("disciplines", this.state.disciplines);
      data.append("planTypeId", this.state.planTypeId);
      data.append(
        "planSubmitDate",
        API_CONFIG.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED
          ? this.state.selectedEffectiveFrom
          : "01/01/1900"
      );
      data.append(
        "dueDate",
        API_CONFIG.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED
          ? this.state.selectedDueDate
          : "01/01/1900"
      );
      data.append(
        "shareable",
        API_CONFIG.FEATURE_SHARE_VISIBILITY_ENABLED
          ? this.state.share_isChecked
          : false
      );

      this.props.createFormDataPost(data, (response) => {
        // form data for supporting doc
        let docTypeOthers = documentTypes.filter(
          (type) => type.documentTypes.toLowerCase() === "others"
        )[0];

        let requests = uploadedAddDocs.map((file) => {
          return new Promise((resolve) => {
            var formDataSupportDoc = new FormData();
            formDataSupportDoc.append("file", file);
            formDataSupportDoc.append("documentId", docTypeOthers.id);
            formDataSupportDoc.append("documentName", file.name);
            formDataSupportDoc.append("jobId", response?.data?.jobId);
            formDataSupportDoc.append("documentExtension", file.type);
            axios
              .post(
                API_CONFIG.API_ROOT + "safecv/api/v1/supportdoc",
                formDataSupportDoc,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                }
              )
              .then((res) => {
                if (res.status && res.status === 200) {
                  resolve();
                } else throw res;
              })
              .catch(() => {
                // to show error for specific document
                toast.error(MESSAGE.errorAdditionalDocUpload(file.name));
              });
          });
        });

        // to show additional document uploaded success
        requests.length &&
          Promise.all(requests).then(() => {
            toast.success(MESSAGE.ADDITIONAL_DOCS_SUCCESS);
          });

        this.props.redirect(true);

        if (
          API_CONFIG.FEATURE_GT_UPLOAD_ENABLED &&
          response.data.jobId != undefined &&
          this.state.gtFile
        ) {
          let data = new FormData();
          data.append("file", this.state.gtFile);
          this.props.uploadGT(response.data.jobId, data);
        }
      });
    } else if (this.state.planName === "") {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.PLANNAME);
    } else if (this.state.selectedUploadedFile === null) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.UPLOAD_FILE);
    } else if (this.state.state === "") {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.STATE);
    } else if (this.state.jurisdictionId === null) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.JURIDICTION);
    } else if (this.state.disciplines.length === 0) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.DISCIPLINE);
    } else if (this.state.planTypeId === null) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.PLANTYPE);
    } else if (supportDocNameDuplicates) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.DUPLICATE_DOCUMENT_NAME);
    } else if (this.state.codebookId === null) {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.CODEBOOK);
    } else {
      toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.MANDATORY);
    }
  };

  render() {
    const { spinnerLoading, spinnerLoadingAddPlan } = this.props;

    return (
      <div
        disabled={spinnerLoadingAddPlan}
        className={spinnerLoadingAddPlan ? "div-disable-addplan" : ""}
      >
        <NavigationBar />
        <div className="container-fluid">
          <div className="row">
            <div className="imageblock">
              <Link
                to={{ pathname: "/plans", search: `${this.props.queryparams}` }}
              >
                <img className="imagestyle" src={leftarrow} alt="arrow" />
              </Link>
            </div>
            <label className="textstyle">Add Plan</label>
            <hr className="zero-padding line" />
          </div>
          <Upload
            planName={this.state.planName}
            onChangeHandler={this.onChangeHandler}
            openModal={this.openModal}
            handleJurisdictionListChange={this.handleJurisdictionListChange}
            handlePlanTypeListChange={this.handlePlanTypeListChange}
            handleEffectiveFromChange={this.handleEffectiveFromChange}
            handleDueDateChange={this.handleDueDateChange}
            handleCodebookListChange={this.handleCodebookListChange}
            modalIsOpen={this.state.modalIsOpen}
            afterOpenModal={this.afterOpenModal}
            closeModal={this.closeModal}
            updateModal={this.updateModal}
            statelist={this.props.states}
            planTypeId={this.state.planTypeId}
            selectedPlanType={this.state.selectedPlanType}
            selectedEffectiveFrom={this.state.selectedEffectiveFrom}
            selectedDueDate={this.state.selectedDueDate}
            selectedstate={this.state.selectedstate}
            selectedjurisdiction={this.state.selectedjurisdiction}
            codebookId={this.state.codebookId}
            selectedCodebook={this.state.selectedCodebook}
            handleStateListChange={this.handleStateListChange}
            updateUploadedFile={this.updateUploadedFile}
            share_isChecked={this.state.share_isChecked}
            shareCheckBoxToggle={this.shareCheckBoxToggle}
            isOriginalPlan={this.state.isOriginalPlan}
            isAdditional={null}
            setUploadedAddDocs={(files) =>
              this.setState({ uploadedAddDocs: files })
            }
          />
          <Disciplines
            selectAllCheckBoxes={this.selectAllCheckBoxes}
            criterialist={this.state.criterialist}
            toggleCheckBoxChange={this.toggleCheckBoxChange}
          />
          <Footer handleProcessPlan={this.handleProcessPlan} />
          <div className="addPlanLoader">
            <FadeLoader
              css={override}
              height={15}
              width={5}
              radius={2}
              margin={2}
              color={"#4183C5"}
              loading={spinnerLoading || spinnerLoadingAddPlan}
            />
          </div>
        </div>
        <AppFooter />
      </div>
    );
  }
}

AddPlans.propTypes = {
  fetchCriteria: PropTypes.func.isRequired,
  createFormDataPost: PropTypes.func.isRequired,
};

const mapStatetoProps = (state) => ({
  states: state.criteria.states,
  spinnerLoading: state.criteria.spinnerLoading,
  spinnerLoadingAddPlan: state.plans.spinnerLoading,
  planTypes: state.criteria.planTypes,
  codebooks: state.criteria.codebooks,
  queryparams: state.plans.queryparams,
  API_times: state.plans.API_times,
  documentTypes: state.plans.documentTypes,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    createFormDataPost: (data, postAddPlan) => {
      dispatch(createFormDataPost(data, postAddPlan));
    },
    uploadGT: (jobId, data) => {
      dispatch(uploadGT(jobId, data));
    },
    fetchCriteria: () => {
      dispatch(fetchCriteria());
    },
    fetchStateList: () => {
      dispatch(fetchStateList());
    },
    fetchJurisdictionList: (state_id) => {
      dispatch(fetchJurisdictionList(state_id));
    },
    fetchPlanType: (jurisdictionId) => {
      dispatch(fetchPlanType(jurisdictionId));
    },
    fetchCodebook: (stateId, jurisdictionId, planTypeId, submitDate) => {
      dispatch(fetchCodebook(stateId, jurisdictionId, planTypeId, submitDate));
    },
    restPlantype: () => {
      dispatch(restPlantype());
    },
    resetCodebook: () => {
      dispatch(resetCodebook());
    },
    redirect: (additionalDocFlag) => {
      dispatch(redirect(additionalDocFlag));
    },
    getDocumentTypes: () => {
      dispatch(getDocumentTypes());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(AddPlans);
